import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** LA申請種別 */
enum LaApplicationType {
  laStartRegistration = 'LA011',
  laStartRegistrationCancel = 'LA012',
  laCancelBeforeMaturity = 'LA071',
  laCancelBeforeMaturityCancel = 'LA072',
  laContractInfoChange = 'LA081',
  laContractInfoChangeCancel = 'LA082',
  laArticleInfoChange = 'LA101',
  laArticleInfoChangeCancel = 'LA102',
  reLeaseAndContractExpired = 'LA121',
  reLeaseAndContractExpiredCancel = 'LA122',
}

const nameConfig = {
  laStartRegistration: new Map([[Locale.ja, 'リース開始登録']]),
  laStartRegistrationCancel: new Map([[Locale.ja, 'リース開始登録取消']]),
  laCancelBeforeMaturity: new Map([[Locale.ja, 'リース中途解約']]),
  laCancelBeforeMaturityCancel: new Map([[Locale.ja, 'リース中途解約取消']]),
  laContractInfoChange: new Map([[Locale.ja, 'リース契約情報変更']]),
  laContractInfoChangeCancel: new Map([[Locale.ja, 'リース契約情報変更取消']]),
  laArticleInfoChange: new Map([[Locale.ja, 'リース物件情報変更']]),
  laArticleInfoChangeCancel: new Map([[Locale.ja, 'リース物件情報変更取消']]),
  reLeaseAndContractExpired: new Map([[Locale.ja, '再リース及び契約満了']]),
  reLeaseAndContractExpiredCancel: new Map([[Locale.ja, '再リース及び契約満了取消']]),
};

const toEnum = rawValueToEnum(LaApplicationType, LaApplicationType.laStartRegistration);
const toDisplay = enumToName(LaApplicationType, nameConfig);
const toDisplayWithPrefix = enumToName(LaApplicationType, nameConfig, { prefix: true });

export const laApplicationType = {
  enum: LaApplicationType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { LaApplicationType };
